import { useState, useEffect } from "react";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import IAIAdminDashboardModel from "../../../models/admin/dashboard/response/IAIAdminDashboardModel";
import modalUtils from "../../../utils/modal-utils";
import toasterUtils from "../../../utils/toaster-utils";
import adminDashboardService from "../../../services/admin/admin-dashboard-service";
import loaderUtils from "../../../utils/loader-utils";
import IAIAdminSearchInputModel from "../../../models/admin/dashboard/request/IAIAdminSearchInputModel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import dateTimeUtils from "../../../utils/date-utils";

import "./AdminDashboardComponent.css"

const AdminDashboardComponent = () => {
    const [adminDasgboardDetails, setAdminDasgboardDetails] = useState<IAIAdminDashboardModel | null>(null);
    const [refreshDashboard, setRefreshDashboard] = useState<number>(2);
    const [startDateSearch, setStartDateSearch] = useState<Dayjs | null>(dayjs());
    const [endDateSearch, setEndDateSearch] = useState<Dayjs | null>(dayjs());

    useEffect(() => {
        getAdminDashboardDetails();
    }, []);

    const searchDashboard = () => {
        if (startDateSearch === null || endDateSearch === null) {
            toasterUtils.showError("Please select Start Date and End Date");
            return;
        } else {
            getAdminDashboardDetails();
        }
    }

    const getAdminDashboardDetails = () => {
        let request: IAIAdminSearchInputModel = {
            startDate: dateTimeUtils.getFormattedDate(startDateSearch ? startDateSearch.toDate() : new Date()),
            endDate: dateTimeUtils.getFormattedDate(endDateSearch ? endDateSearch.toDate() : new Date()),
            companyId: []
        }
        setRefreshDashboard(2);
        modalUtils.showLoader();
        adminDashboardService.getIAIAdminDashboard(request).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setAdminDasgboardDetails(res.data);
            setRefreshDashboard(refreshDashboard * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            setRefreshDashboard(refreshDashboard * 5);
            toasterUtils.showError(error);
        });
    };

    const clearSearch = () => {
        setStartDateSearch(dayjs().subtract(15, "day"));
        setEndDateSearch(dayjs());
        getAdminDashboardDetails();
    };

    return (
        <div>
            <div className="card card-white">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-3">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Start Date"
                                    value={startDateSearch}
                                    onChange={(newValue) => setStartDateSearch(newValue)}
                                    format="YYYY-MMM-DD"
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            margin: "normal",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-3">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="End Date"
                                    value={endDateSearch}
                                    onChange={(newValue) => setEndDateSearch(newValue)}
                                    format="YYYY-MMM-DD"
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            size: "small",
                                            margin: "normal",
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-3 button-align-center">
                            <Button variant="contained" color="success" onClick={() => searchDashboard()} startIcon={<SearchIcon />}>
                                Search
                            </Button>
                            <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<ClearIcon />} sx={{ ml: 2 }}>
                                Clear
                            </Button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="dashboard-container">
                <div className="dashboard-grid">
                <div className="dashboard-card">
                    <h3>No of profiles Added</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.noOfCandidatesAdded}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>No of Interviews Scheduled</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.noOfInterviewsScheduled}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>No of Interviews Rated</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.noOfInterviewsRated}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>Self Registered Candidates</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.iaiCandidates}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>No of Companies Profiles Added</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.noOfCompaniesAddedCandidates}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>Rejected Candidates</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.noOfCandidatesRejected}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>Escalations</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.noOfEscalations}</span></p>
                </div>
                <div className="dashboard-card">
                    <h3>Today's Interviews</h3>
                    <p className="dashboard-number"><span>{adminDasgboardDetails?.todayInterviews}</span></p>
                </div>
                </div>
            </div>
        </div>
    );
};
export default AdminDashboardComponent;